import { Link } from 'react-router-dom';
import { adminBaseURL } from '../../../constants/API';
import FeedbackModal from '../../../pages/auth/FeedbackModal';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useContext, useState } from 'react';
import ThankYouModal from '../../../pages/auth/ThankYouModal';
import CreateComplaintModal from '../../manage_account/helpSupport/CreateComplaintModal';
import { Language } from '../../../App';

const FooterLinks = ({top}) => {
  const {lang} = useContext(Language)
  const [showModal, setShowModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showThanks, setShowThanks] = useState(false);
  const [showHelpSupport, setShowHelpSupport] = useState(false);

  const handleFeedbackSubmit = async (data) => {
    try {
      setLoader(true)
      // Send POST request to the app/feedback endpoint with experience and description as payload
      const response = await axios.post(adminBaseURL + "app/feedback", {
        title: data.experience,
        feedback: data.description,
      });

      // After success, show the "Thank You" message
      if (response.data.status) {
        setLoader(false)
        setShowThanks(true);
        setShowModal(false);
      }
    } catch (error) {
      // Handle error if the request fails
      console.error('Error submitting feedback:', error);
      setLoader(false)
      // You can optionally display an error message to the user
      toast.error('There was an error submitting your feedback. Please try again later.');
    }
  };
  function getCurrentYear() {
  return new Date().getFullYear();
}
const year = getCurrentYear();
  return (
    <>
      <div
        className="w-100"
        style={{
          position: top && top !== 'auto' ? 'sticky' : 'static',
          top: top || 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
        }}
      >
        <nav
          style={{ color: '#adadad' }}
          className="d-flex justify-content-center flex-wrap gap-2 small mb-1"
        >
          <a
            href="https://medicalradar.es/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: '#adadad' }}
          >
            {lang.privacy_policy}
          </a>

          <span
            style={{
              fontSize: '0.75rem',
              color: '#adadad',
              display: 'flex',
              alignItems: 'center', // Vertically center the dot
            }}
          >
            •
          </span>
          <Link to="#" style={{ textDecoration: 'none', color: '#adadad' }}>
            {lang.cookies}
          </Link>
          <span
            style={{
              fontSize: '0.75rem',
              color: '#adadad',
              display: 'flex',
              alignItems: 'center', // Vertically center the dot
            }}
          >
            •
          </span>
          <a
            href="https://medicalradar.es/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: '#adadad' }}
          >
            {lang.terms_conditions}
          </a>

        </nav>

        <nav
          className="d-flex justify-content-center flex-wrap gap-2 small mb-1"
          style={{ color: '#adadad' }}
        >
          <Link to="#" onClick={()=>setShowHelpSupport(true)} style={{ textDecoration: 'none', color: '#adadad' }}>
            {lang.help_support}
          </Link>
          <span
            style={{
              fontSize: '0.75rem',
              color: '#adadad',
              display: 'flex',
              alignItems: 'center', // Vertically center the dot
            }}
          >
            •
          </span>
          <Link to="#" onClick={()=>setShowModal(true)} style={{ textDecoration: 'none', color: '#adadad' }}>
            {lang.give_feedback}
          </Link>
          <span
            style={{
              fontSize: '0.75rem',
              color: '#adadad',
              display: 'flex',
              alignItems: 'center', // Vertically center the dot
            }}
          >
            •
          </span>
          <a
            href="https://medicalradar.es/eula"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: '#adadad' }}
          >
            {lang.eula_disclaimer}
          </a>

        </nav>

        <p className="text-center small" style={{ color: '#adadad' }}>
          © {year} Ophthalmology Radar
        </p>
      </div>
      {showModal && <FeedbackModal isOpen={showModal} toggle={() => setShowModal(false)}
        onSubmit={handleFeedbackSubmit}
        loader={loader}
      />}
      <ThankYouModal
        isOpen={showThanks}
        toggle={() => setShowThanks(false)}
      />
      {showHelpSupport&&<CreateComplaintModal isOpen={showHelpSupport} toggle={setShowHelpSupport}/>}
    </>
  );
};

export default FooterLinks;